// Address of the admin panel, which is a separate site with its own login.
// REACT_APP_ADMIN_URL overrides it (local development points it at the admin
// dev server).
export const ADMIN_PANEL_URL = (
  process.env.REACT_APP_ADMIN_URL || 'https://admin.nobrokerages.online/login'
).trim();
